{
  "sdk-download-android": "အန်းဒရွိုက်အတွက် ဒေါင်းလုဒ်လုပ်မည်",
  "sdk-connect": "ချိတ်ဆက်မည်",
  "sdk-download-ios": "iOS အတွက် ဒေါင်းလုဒ်လုပ်မည်",
  "sdk-install": "ထည့်သွင်းမည်",
  "sdk-modal-instruct-1": "1. Open Binance app",
  "sdk-modal-instruct-2": "ပင်မမျက်နှာပြင်မှ {{icon}} ကိုနှိပ်ပါ။",
  "sdk-modal-title": "Connect With Binance",
  "sdk-no-app": "Binance App မရှိသေးဘူးလား။"
}